import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "paint",
  "use": "paint-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"paint\"><path d=\"M23.51,1.09A3.42,3.42,0,0,0,21,.46a.5.5,0,0,0-.39.19L10.78,13l.7.72.92.94.7.72L23.87,3.8A.5.5,0,0,0,24,3.46V3.14A2.68,2.68,0,0,0,23.51,1.09Z\" /><path d=\"M11.72,15.43l-.86-.88-.71-.72-1,1.3a4,4,0,0,0-4.66,1.35,6,6,0,0,0-.77,1.77C3.22,19.76,2.79,21.07.52,21a.5.5,0,0,0-.38.85,6.86,6.86,0,0,0,5,2.2c2.85,0,5.69-1.82,6.46-4.14a3.43,3.43,0,0,0-.16-2.65l1-1.06Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol